import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { formatMoney } from "./format";

const hasValue = value => typeof value === "number" || !!value;

export const MoneyField = ({ value, onChange, ...rest }) => {
  const [_value, _setValue] = useState("");

  useEffect(() => {
    const newValue = hasValue(value) ? formatMoney(value) : "";
    _setValue(newValue);
  }, [value]);

  const handleChange = e => {
    let newValue = e.target.value.replace(/\D/g, "");

    if (!newValue || newValue === "00") {
      return onChange && onChange(e, .0);
    }

    newValue = parseFloat(newValue) / 100;
    onChange && onChange(e, newValue);
  }

  return (
    <TextField
      {...rest}
      inputProps={{ inputMode: 'numeric' }}
      value={_value}
      onChange={handleChange}
    />
  )
}
